import classNames from 'classnames'
import React from 'react'

const Lock: React.FC<{ className?: string }> = ({ className }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" fill="none" viewBox="0 0 16 22">
		<path
			className={classNames(className ?? 'fill-brand-primary-md')}
			d="M14.754 9.112h-.87V5.99C13.883 2.687 11.243 0 8 0S2.117 2.687 2.117 5.99v3.122h-.87C.557 9.112 0 9.68 0 10.381v10.35C0 21.431.558 22 1.246 22h13.508c.688 0 1.246-.568 1.246-1.269v-10.35c0-.701-.558-1.269-1.246-1.269zm-5.428 9.09H6.674l.474-2.304a1.623 1.623 0 01-.74-1.366c0-.895.713-1.621 1.592-1.621.88 0 1.592.726 1.592 1.62 0 .576-.296 1.079-.74 1.367l.474 2.303zm2.458-9.09H4.216V5.99c0-2.124 1.697-3.853 3.784-3.853 2.087 0 3.784 1.729 3.784 3.853v3.122z"
		/>
	</svg>
)

export default Lock
